import { React, useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const Uk = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Country"    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Country"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const countries = [
        {
            img: "images/University-of-Bedfordshire.jpg", universityname: "University of Bedfordshire", location: "Luton, United Kingdom", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$11,591", para2: "NA", para3: "NA"
        },
        {
            img: "images/free-building-icon.png", universityname: "Teesside University", location: "Middlesbrough, North Yorkshire, United Kingdom", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$10,835", para2: "NA", para3: "NA"
        },
        {
            img: "images/De-Montfort-University.jpg", universityname: "De Montfort University", location: "Leicester, United Kingdom", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$12,966", para2: "NA", para3: "801-1000"
        },
        {
            img: "images/University_of_oxford.jpg", universityname: "University of Oxford", location: "Oxford, United Kingdom", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$29,450", para2: "NA", para3: "3"
        },
        {
            img: "images/free-building-icon.png", universityname: "Newcastle University", location: "Newcastle upon Tyne, United Kingdom", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$16,494", para2: "NA", para3: "110"
        },
        {
            img: "images/nottingham-trent-university-city-campus.jpg", universityname: "Nottingham Trent University", location: "Nottingham, United Kingdom", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$13,286", para2: "NA", para3: "751-800"
        },
        {
            img: "images/Middlesex-University.png", universityname: "Middlesex University", location: "London, United Kingdom", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$12,279", para2: "NA", para3: "701-750"
        },
        {
            img: "images/free-building-icon.png", universityname: "Cardiff University", location: "Cardiff, Wales, United Kingdom", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$16,906", para2: "NA", para3: "155"
        },
        {
            img: "images/University-of-East-London.jpg", universityname: "University of East London", location: "London, United Kingdom", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$11,637", para2: "NA", para3: "801-1000"
        },
        {
            img: "images/LSE_logo.jpg", universityname: "London School of Economics And Political Science (LSE)", location: "London , United Kingdom", head1: "Annual Tuition", head2: "Acceptance Rate", head3: "Global Rank", para1: "$20,553", para2: "NA", para3: "45"
        }
    ]
    return (
        <>
            <BannerBreadcrumb head={"Universities in UK for International Students"} pagename={"UK"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <p className="loan-elegibility-des mt-0">UK universities are a compelling option for overseas students due to their outstanding educational reputations around the world. World-class programs in an array of subjects are obtainable by top colleges like Imperial College London, the University of Cambridge, and the University of Oxford. Multicultural campuses in the UK offer a welcoming environment that emphasizes inclusivity and an international outlook. Numerous students can study in the UK thanks to prestigious scholarships like the Chevening Scholarship and an abundance of financial aid options. Additionally, graduates can obtain useful experience through post-study job opportunities made possible by the Graduate Route visa. The UK is a great place to study since it offers both professional prospects and excellent education.</p>
                            <h5 className="about-head mb-4">Explore Our List of UK Universities</h5>
                            <div className="row">
                                {countries.map((item, index) => (
                                    <div className="col-md-6">
                                        <div className="scholar-card">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <img src={item.img} alt="University Images" className="img-fluid countryimg" />
                                                </div>
                                                <div className="col-md-9 d-block my-auto">
                                                    <h5 className="scholar-head">{item.universityname}</h5>

                                                </div>
                                                <p className="scholar-des mb-0 mt-4" style={{ marginLeft: "-6px", fontSize: "16px" }}><LocationPinIcon /> {item.location}</p>
                                                <div className="col-md-12 mt-3">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head1}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades">{item.para1}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head2}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades">{item.para2}</p>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <h6 className="list-head">{item.head3}</h6>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p className="list-heades mb-0">{item.para3}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Uk;